
const base_url =   {
   "base_url": "https://api.kichaarojes.in",
   "base_urlll": "http://localhost:3002"
}

export default  base_url 
